import * as React from 'react';
import { Collapse } from 'antd';
import clsx from 'clsx';
import { FacebookMessengerShareButton, FacebookShareButton } from 'react-share';
import { ReactComponent as FacebookIcon } from './Facebook.svg';
import { ReactComponent as FacebookMessengerIcon } from './Messenger.svg';
import { ReactComponent as EmailIcon } from './Instagram.svg';
import { ReactComponent as Arrow } from './arrow.svg';

import './MobileFooter.scss';
import { ShareInfor } from '../../const/ShareInfor';

const { Panel } = Collapse;

export const policyData = [
  {
    title: 'Điều kiện & Điều khoản',
    link: 'https://doitac.mytour.vn/help/list?tab=dieu-kien-dieu-khoan',
  },
  // {
  //   title: 'Chính sách và quy định chung',
  //   link: 'https://mytour.vn/news/135152-chinh-sach-va-quy-dinh-chung.html',
  // },
  // {
  //   title: 'Quy định về thanh toán',
  //   link: 'https://mytour.vn/news/135633-quy-dinh-ve-thanh-toan.html',
  // },
  // {
  //   title: 'Quy định về xác nhận thông tin đặt phòng',
  //   link: 'https://mytour.vn/news/135634-quy-dinh-ve-xac-nhan-thong-tin-dat-phong.html',
  // },
  // {
  //   title: 'Chính sách về hủy đặt phòng và hoàn trả tiền',
  //   link: 'https://mytour.vn/news/135154-chinh-sach-huy-phong-va-hoan-tien.html',
  // },
  // {
  //   title: 'Chính sách bảo mật thông tin',
  //   link: 'https://mytour.vn/news/135636-chinh-sach-bao-mat-thong-tin-danh-cho-website-tmdt.html',
  // },
  // {
  //   title: 'Quy chế hoạt động',
  //   link: 'https://mytour.vn/news/135155-quy-che-hoat-dong.html',
  // },
  // {
  //   title: 'Chính sách bảo mật',
  //   link: 'https://mytour.vn/news/135156-chinh-sach-bao-mat-thong-tin-danh-cho-san-gdtmdt.html',
  // },
  // {
  //   title: 'Quy trình giải quyết tranh chấp, khiếu nại',
  //   link: 'https://mytour.vn/news/135420-quy-trinh-giai-quyet-tranh-chap-khieu-nai.html',
  // },
];

export const customerAndPartner = [
  { title: 'Đăng nhập HMS', link: 'https://hms.mytour.vn/login?from=%2F' },
  { title: 'Tuyển dụng', link: 'https://career.mytour.vn/' },
  { title: 'Liên hệ', link: 'https://mytour.vn/help/30-lien-he.html' },
];
const MobileFooter = (props) => {
  return (
    <div className='mobile-footer'>
      <div className='bound'>
        <div>
          <img
            className='logo_footer-mobile'
            src='https://storage.googleapis.com/tripi-assets/mytour/icons/icon_logo_mytour_red.svg'
            alt='img_logo'
          />
        </div>
        <div className='highlight company-name'>
          Công ty cổ phần du lịch Việt Nam VNTravel
        </div>
        <div className='company-detail'>
          Hà Nội: (024) 7109 9999
          <br />
          Hồ Chí Minh: 028 7109 9998
          <br />
          Email: admin@mytour.vn
          <br />
          Văn phòng Hà Nội: Tầng 11, Tòa Peakview, 36 Hoàng Cầu, Đống Đa
          <br />
          Văn phòng HCM: Tầng 6, Tòa Nhà Central Park, 117 Nguyễn Du, Q.1
        </div>
      </div>
      <Collapse
        // defaultActiveKey={['1']}
        // onChange={callback}
        expandIconPosition='right'
        className='collapse-container'
        expandIcon={({ isActive }) => {
          // console.log('isActive', isActive);

          return <Arrow className={clsx('arrow-icon', { active: isActive })} />;
        }}
      >
        <Panel className='header-title' header='Chính sách & Quy định' key='1'>
          {policyData.map((x, index) => {
            return (
              <a
                key={x.link}
                href={x.link}
                target='_blank'
                rel='noopener noreferrer'
              >
                <div
                  className={clsx('collapse-content', {
                    'last-item': index === policyData.length - 1,
                  })}
                  key={x.title}
                >
                  {x.title}
                </div>
              </a>
            );
          })}
        </Panel>
        {/* <Panel className='header-title' header='Khách hàng và đối tác' key='2'>
          {customerAndPartner.map((x, index) => {
            return (
              <a
                key={x.link}
                href={x.link}
                target='_blank'
                rel='noopener noreferrer'
              >
                <div
                  className={clsx('collapse-content', {
                    'last-item': index === customerAndPartner.length - 1,
                  })}
                  key={x.title}
                >
                  {x.title}
                </div>
              </a>
            );
          })}
        </Panel> */}
      </Collapse>
      <div className='bound'>
        <div className='row'>
          <div className='highlight'>Kết nối với Mytour.vn</div>
          <div className='share col'>
            <span className={'share-btn'}>
              <FacebookMessengerShareButton
                appId={'1637907399749990'}
                url={ShareInfor.url}
              >
                <FacebookIcon className='share-icon' />
              </FacebookMessengerShareButton>
            </span>
            <span className={'share-btn'}>
              <FacebookShareButton
                url={ShareInfor.url}
                quote={ShareInfor.createShareDescription()}
              >
                <FacebookMessengerIcon className='share-icon' />
              </FacebookShareButton>
            </span>
            <span className={'share-btn'}>
              {/* <EmailShareButton
                url={ShareInfor.url}
                subject={ShareInfor.subject}
                body={ShareInfor.createShareDescription()}
              > */}
              <a
                href='https://www.instagram.com/mytour.vn/'
                target='_blank'
                rel='noopener noreferrer'
              >
                <EmailIcon className='share-icon' />
              </a>
              {/* </EmailShareButton> */}
            </span>
          </div>
        </div>
        <div className='company-detail'>
          Mytour là thành viên của VNTravel Group - Một trong những tập đoàn
          đứng đầu Đông Nam Á về du lịch trực tuyến và các dịch vụ liên quan
        </div>
        <img
          className='logo'
          src='https://storage.googleapis.com/tripi-assets/mytour/icons/icon_company_group.svg'
          alt='vntravel_company_logo'
        ></img>
        <div className='company-detail'>
          Copyright © 2020 - CÔNG TY CỔ PHẦN DU LỊCH VIỆT NAM VNTRAVEL - Đăng ký
          kinh doanh số 0108886908 - do Sở Kế hoạch và Đầu tư thành phố Hà Nội
          cấp lần đầu ngày 04 tháng 09 năm 2019
        </div>
      </div>
    </div>
  );
};

export default MobileFooter;
